import React from 'react'
import getSymbolFromCurrency from 'currency-symbol-map'
import popup from '../../../popup'
import { format } from "date-fns";
import { get } from 'lodash'
import './style.css'
import Cookies from 'js-cookie'

class ThankYou extends React.Component {
getVal(key){
    return get(this.props.metadataMap, key)
 }
  componentDidMount(){
    document.getElementsByClassName('hidden-input')[0].focus()
  }
  render() {
    var plan = this.props.plan
    var pd = plan.planDetails[0]

    //Signup Personalization
    Cookies.set('isThankYouPage', true);

    return (
      <div className="thank-you-screen">
        <input type="text" className="hidden-input" readOnly="readonly"/>
        <div className="title">{this.getVal('thankTitle')}</div>
        {this.props.firstPayment && <div className="desc">
          <span className="first-payment">{this.getVal('thankFirstPay')}</span>
          <span className="price">
            &nbsp;
              {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
            {this.props.firstPayment.amount.toFixed(2)}
          </span> {this.getVal('thankTax')} {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
        </div>}
        <div className="order-details">
          { pd.title || plan.name } <strong>{ /*getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)*/ }{ /*pd.recurringPaymentAmount*/ }</strong> <br/>
          {this.getVal('thankEmail')}: { this.props.user.email }
        </div>
        <div className="help">
          {window.settings.customerService && window.settings.customerService.email &&
            <p>
              <a className="link" href={`mailto:${window.settings.customerService.email}`}>
              {this.getVal('thankContact')}
              </a>
              {this.getVal('thankHelp')}
              <br/>
            </p>
          }
          <span dangerouslySetInnerHTML={{__html:this.getVal('thankVistAcc')}}></span>
        </div>
        <div className="button site-background-color" onClick={ _ => {
          popup.hide();
        }}>
        {this.getVal('thankClose')}
        </div>
      </div>
    )
  }
}

export default ThankYou;